import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@rtkwlf/pro-regular-svg-icons/faBookmark';
import { Link, generatePath, useParams } from 'react-router-dom';

import { ListItemButton } from '../../../components/list';

import { MenuLinkContent } from './menu-link-content';
import type { MenuItemInternalProps } from './menu-link-types';

export const MenuLinkBookmark = ({
  icon,
  title,
  routePrefix,
  segment,
  ...rest
}: MenuItemInternalProps) => {
  const params = useParams();

  const to = generatePath(`${routePrefix}${segment}`, params);

  const titleStartIcon = (
    <FontAwesomeIcon
      icon={faBookmark}
      color="var(--aw-palette-text-secondary)"
    />
  );

  return (
    <ListItemButton component={Link} to={to} {...rest}>
      <MenuLinkContent
        icon={icon}
        title={title}
        titleStartIcon={titleStartIcon}
      />
    </ListItemButton>
  );
};
